/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { CellConfig } from "./CellConfig";
export const RecordConfig = core.serialization.object({
    readonly: core.serialization.boolean().optional(),
    fields: core.serialization.record(core.serialization.string(), CellConfig).optional(),
    markedForDeletion: core.serialization.boolean().optional(),
});
